export const TeamInfoTheme = {
    /** 主视觉背景卡片 */
    BackgroundImageCard: 'https://p0.meituan.net/ingee/e238767cca15e49d1b9a64938efc010313980.png',
    /** Call 值 Icon (Call 值旁) */
    CallIcon: 'https://p0.meituan.net/ingee/efe67ddca5867c194aabfc9933272d26741.png',
    /** 奖励按钮 */
    RewardButtonImage: 'https://p0.meituan.net/ingee/45553e7317e25bfa4bf9d2bcf5b3bec110751.png',
    /** 邀请打 Call 按钮 */
    InviteCallButtonImage: 'https://p0.meituan.net/ingee/9afceea05fcf5e0a0cc51e7d7f1e4afe23986.png',
    /** 排行榜按钮 */
    RankingListButtonImage: 'https://p0.meituan.net/ingee/94bc598d487fe746aa823da85e59c65f10477.png',
    /** 问号图标 */
    QuestionIcon: 'https://img.meituan.net/makerjiulv/68e502e8872894dd32c15a7661f0c62518760.png'
};
export const TeamRecommendTheme = {
    /** 背景图 */
    BackgroundImage: 'https://p0.meituan.net/ingee/56113ac811d35b06db11e8c07efb19938355.png',
    /** 标题图 */
    TitleImage: 'https://p0.meituan.net/ingee/188ef7731ff5c69623c76536c1e9723f8222.png',
    TitleHeaderImage: 'https://p0.meituan.net/ingee/205f150beab66f74ad48235850c297188045.png',
    /** 顶部操作区 - 加入或创建队 Icon */
    TopActionJoinIcon: 'https://p0.meituan.net/ingee/7014a11cbd5690b2f3661e6db702dcb41665.png',
    /** 顶部操作区 - 邀好友打Call Icon */
    TopActionInviteIcon: 'https://p0.meituan.net/ingee/46baf6eba88686290bb0894c08c646142343.png',
    /** 顶部操作区 - 一起赢免单 Icon */
    TopActionWinIcon: 'https://p0.meituan.net/ingee/9e962e0613ea86660fec2fa78709e2431782.png',
    /** 顶部操作区 - 箭头分隔符 */
    TopActionArrow: 'https://p0.meituan.net/ingee/01d0b7091586c9ce48ff9756c809ca70297.png',
    /** Call值图标 */
    CallIcon: 'https://p0.meituan.net/ingee/efe67ddca5867c194aabfc9933272d26741.png',
    /** 空状态图 */
    EmptyImage: 'https://p0.meituan.net/travelcube/70ebeaaad24595c07aa27e01375d104512206.png',
    /** 创建战队按钮 */
    CreateTeamButton: 'https://p0.meituan.net/ingee/67d047f43170a6e0bb8a16a61fa0536337364.png',
    /** 复选框选中图标 */
    CheckboxCheckedIcon: 'https://p0.meituan.net/ingee/cc3105e3bf3a9f19cee0e74aecdc476a440.png'
};
export const TeamStageResultTheme = {
    /** 背景卡片 */
    BackgroundCard: 'https://p0.meituan.net/ingee/51bdc1aac79a1e978845f73765c019fb8625.png',
    /** Call值图标 */
    CallIcon: 'https://p0.meituan.net/ingee/163d0b40bd592c7129d73da9f2067659731.png',
    /** 奖励记录按钮 */
    RewardRecordButton: 'https://p0.meituan.net/ingee/45553e7317e25bfa4bf9d2bcf5b3bec110751.png',
    /** 奖励记录按钮（无队伍状态） */
    RewardRecordButtonNoTeam: 'https://p0.meituan.net/ingee/fb87277cfe6f149c653219ac37161d5f10950.png',
    /** 去预约按钮 */
    SubscribeButton: 'https://p0.meituan.net/ingee/a357c14f6fffa2085a54298a6688739126250.png',
    /** 去使用按钮 */
    UseButton: 'https://p0.meituan.net/ingee/2170c39c799a490237a471c7e99fd9dc25292.png',
    /** 查看获奖名单按钮 */
    ViewWinnerListButton: 'https://p0.meituan.net/ingee/3abfaf24023bb92370f230c4184ce39a29899.png',
    /** 查看获奖名单按钮（无队伍状态） */
    ViewWinnerListButtonNoTeam: 'https://p0.meituan.net/ingee/453d43a64f5a367512c1d5e1d76eb1d829894.png',
    /** 排行榜按钮 */
    RankingButton: 'https://p0.meituan.net/ingee/94bc598d487fe746aa823da85e59c65f10477.png'
};
export const RankingListTheme = {
    /** 弹窗背景图 */
    BackgroundImage: 'https://p0.meituan.net/ingee/af12f997ba4f1cca553cfa8b9944154816409.png',
    /** 标题图 */
    TitleImage: 'https://p0.meituan.net/ingee/3154f7fb15d23c0f9c54daac62f6b85a7645.png',
    /** 关闭按钮 */
    CloseButton: 'https://p0.meituan.net/ingee/e18359a5f095559a508718be72c2b0301324.png',
    /** Top1 背景 */
    Top1Background: 'https://p0.meituan.net/ingee/dbf524939057c77045e143e44787d5972931.png',
    /** Top1 头像边框 */
    Top1AvatarBorder: 'https://p0.meituan.net/ingee/c6958ed09410b9cbb4dbe4bc96b9a0321236.png',
    /** Top1 排名图标 */
    Top1RankingIcon: 'https://p0.meituan.net/ingee/afee71895696aa29f196909cdf28e1b01750.png',
    /** Top2 背景 */
    Top2Background: 'https://p0.meituan.net/ingee/8b0846f79fdf6f82182df8c82d6257d12998.png',
    /** Top2 头像边框 */
    Top2AvatarBorder: 'https://p0.meituan.net/ingee/e7aff6feac95a3adbd60288512fe8f631391.png',
    /** Top2 排名图标 */
    Top2RankingIcon: 'https://p0.meituan.net/ingee/9dac7d48da02725bb97ee9a67b44b2c22058.png',
    /** Top3 背景 */
    Top3Background: 'https://p0.meituan.net/ingee/365e5d4be1b711724e99251f339c13f53075.png',
    /** Top3 头像边框 */
    Top3AvatarBorder: 'https://p0.meituan.net/ingee/cc5aa569c67883f9755abc8da766238b1447.png',
    /** Top3 排名图标 */
    Top3RankingIcon: 'https://p0.meituan.net/ingee/cd15afc71c15ae3abfcdb26dcb2a379d2369.png',
    /** 戳一戳按钮 */
    PokeButton: 'https://img.meituan.net/makerjiulv/d466ef597ed8571f1d174508b32920255307.png'
};
export const RewardRecordsTheme = {
    /** 弹窗背景图 */
    BackgroundImage: 'https://p0.meituan.net/ingee/af12f997ba4f1cca553cfa8b9944154816409.png',
    /** 标题图 */
    TitleImage: 'https://p0.meituan.net/ingee/c41b04ed73652ef0448502473091107a5615.png',
    /** 关闭按钮 */
    CloseButton: 'https://p0.meituan.net/ingee/e18359a5f095559a508718be72c2b0301324.png',
    /** 空状态图标 */
    EmptyIcon: 'https://p0.meituan.net/ingee/07b6a302ba298c7b4ff073ba859eb05450442.png'
};
